import React, { useEffect } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Card, CardContent, CircularProgress, DialogContent, Divider, Slide, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useSelector } from 'react-redux';
import { transactionDetailsSaga } from '../../redux/saga/ordersPageSelectors';
import { formatAMPM, formatMonth, updateTimeOffset } from '../utils/format.helpers';
import { useState } from 'react';
import { ORDER_DETAILS, GET_HELP, DELIVERED_TEXT, CANCELLED_TEXT, CUSTOMER_TEXT, DRIVER_TEXT, STORE_LOCATION, DELIVERY_TIME, PICK_UP_TIME, CANCELLED_DESC, SUBTOTAL_TEXT, MARKET_TEXT, TAX_TEXT, CUSTOMER_REFUND_TEXT, PAYOUT_TEXT, TRANS_TEXT, DELIVERY_DETAILS, OREDER_RECIPT_TEXT, DELIVERED_DES, SERVER_ERROR, SERVER_ERROR_DESC } from '../../constants/ordersPageConstants';
import './OrderDetailsCard.scss';
import { getItemNameOrderDetailsCard } from '../utils/format.helpers';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='left' ref={ref} {...props} />;
});

function OrderDetailsCard(props) {

    let { onClose, selectedRow, storeOffset, open, openHelp } = props;
    const [loading, setLoading] = useState(true);
    const [selectedValue, setSelectedValue] = useState(null);
    let transactionDetails = useSelector(transactionDetailsSaga);
    const [listHeight, setListHeight] = useState(200);
    const [showFailure, setShowFailure] = useState(false);
	const enablepaymentsTab = process.env.REACT_APP_ENABLE_PAYMENTS_TAB === 'true';

    useEffect(() => {
        if (transactionDetails?.data && selectedRow?.storeUUID) {
            setShowFailure(false);
            let tempObj = JSON.parse(JSON.stringify(transactionDetails));
            if (tempObj?.data?.delivery_details?.deliveredTime) {
                updateTimeOffset(selectedRow.storeUUID, storeOffset, tempObj?.data?.delivery_details,'deliveredTime')
            }

            if (transactionDetails?.data?.delivery_details?.pickupTime) {
                updateTimeOffset(selectedRow.storeUUID, storeOffset, transactionDetails?.data?.delivery_details,'pickupTime')
            }

            if (transactionDetails?.data?.delivery_details?.quotedDeliveryTime) {
                updateTimeOffset(selectedRow.storeUUID, storeOffset, transactionDetails?.data?.delivery_details,'quotedDeliveryTime')
            }

            if (transactionDetails?.data?.delivery_details?.quotedPickupTime) {
                updateTimeOffset(selectedRow.storeUUID, storeOffset, transactionDetails?.data?.delivery_details,'quotedPickupTime')
            }
            setSelectedValue(tempObj);
            setLoading(false);
        } else if (transactionDetails && transactionDetails?.data === undefined) {
            setLoading(false);
            setShowFailure(true);
        }
    }, [transactionDetails]);

    useEffect(() => {
        let offsetValue = selectedValue?.data?.order_status === 'COMPLETE' ? 910 : 820;
        let listH = (window.innerHeight - offsetValue) > 100 ? (window.innerHeight - offsetValue) : 100;
        listH = listH > 400 ? 400 : listH
        listH = listH < 100 ? 100 : listH;
        setListHeight(listH);
    }, [window.innerHeight])

    const handleClose = () => {
        onClose(null);
    };

    useEffect(() => {
        if (open) {
            setLoading(true)
        }
    }, [open]);

    return (
        <>
            {
                <Dialog className='dialog-summary-cont'
                    TransitionComponent={Transition}
                    keepMounted
                    slotProps={{ backdrop: { sx: { background: 'rgba(255, 255, 255, 0.25)' } } }}
                    aria-labelledby='alert-dialog-slide-title'
                    aria-describedby='alert-dialog-slide-description'
                    componentsProps={{ backdrop: { style: { backgroundColor: 'rgb(241 241 241 / 40%)' } } }}
                    sx={{
                        borderRadius: '20px',
                        '& .MuiDialog-paper': {
                            minWidth: '475px',
                            maxWidth: '475px',
                            maxHeight: '100vh',
                            position: 'absolute',
                            right: '0px',
                            margin: '100px 0px 0px 0px',
                            height: '100%',
                            backgroundColor: '#F1F1F1',
                            overflow: 'auto'
                        },
                        margin: '0 auto'
                    }} onClose={handleClose} open={open}>
					<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: 'white', padding: '15px', fontWeight: 700 }} data-testid='order-details-id'>{ORDER_DETAILS} <CloseIcon sx={{ width: '20px', height: '20px', cursor: 'pointer' }} onClick={() => handleClose()} /></DialogTitle>

                    {loading && open ? (<>
                        <div className='dialog-summary-cont--loading'><CircularProgress /></div>
                    </>) : <>
                        <Divider />
                        {!showFailure ? <DialogContent className='dialog-summary-cont--panelcontent'>
                            <Card sx={{ paddingBottom: 0, marginBottom: '8px' }}>
                                <CardContent sx={{ textAlign: 'left', padding: '0px !important' }}>
                                    <Typography variant='h6' component='div'
                                        sx={{
                                            padding: '16px', fontFamily: 'Basis Grotesque Pro',
                                            borderBottom: '1px solid rgb(241, 241, 241)',
                                            borderBottom: 'none',
                                            display: 'flex', justifyContent: 'space-between',
                                            fontSize: '16px', fontWeight: 'bold', lineHeight: '22px'
                                        }}>
                                        {`Order #${selectedValue?.transactionId}`}
                                        <span className='dialog-summary-cont--gethelp' onClick={() => openHelp()}><HelpOutlineIcon />{GET_HELP}</span></Typography>
                                    {
                                        selectedValue?.data?.order_status === 'COMPLETE' ?
                                            <><span className='dialog-summary-cont--delivered'><CheckCircleIcon className='dialog-summary-cont--deliveredIcon' /> {DELIVERED_TEXT}</span>
                                                <p className='dialog-summary-cont--statustext'>{DELIVERED_DES}</p></>
                                            :
                                            <><span className='dialog-summary-cont--cancelled'><WarningAmberIcon className='dialog-summary-cont--cancelledIcon' /> {CANCELLED_TEXT}</span>
                                                <p className='dialog-summary-cont--statustext'>{CANCELLED_DESC}</p></>
                                    }
                                </CardContent>
                            </Card>
                            <Card sx={{ paddingBottom: 0, marginBottom: '8px' }}>
                                <CardContent sx={{ textAlign: 'left', padding: 0 }}>
                                    <Typography variant='h6' component='div'
                                        sx={{
                                            padding: '16px', fontFamily: 'Basis Grotesque Pro',
                                            borderBottom: '1px solid rgb(241, 241, 241)',
                                            borderBottom: 'none',
                                            display: 'flex', justifyContent: 'start',
                                            fontSize: '16px', fontWeight: 'bold', lineHeight: '22px'
                                        }}>
                                        {DELIVERY_DETAILS}
                                        <ErrorOutlineIcon sx={{ marginTop: '-3px', marginLeft: '3px' }} /></Typography>
                                    {
                                        selectedValue?.data?.order_status === 'COMPLETE' ?
                                            <div className='dialog-summary-cont--subCont2'>
                                                <div className='dialog-summary-cont--subCont1'>
                                                    <span className='dialog-summary-cont--headeText'>{PICK_UP_TIME}</span>
                                                    {/*<span className='dialog-summary-cont--subtext'>{`${formatAMPM(selectedValue?.data?.delivery_details?.pickupTime)} (Quoted ${formatAMPM(selectedValue?.data?.delivery_details?.quotedPickupTime)})`}</span>*/}
													<span className='dialog-summary-cont--subtext'>{`${formatAMPM(selectedValue?.data?.delivery_details?.pickupTime)}`}</span>
                                                    <span className='dialog-summary-cont--subtext'>{`${formatMonth(selectedValue?.data?.delivery_details?.pickupTime)}`}</span>
                                                </div>
                                                <div className='dialog-summary-cont--subCont1'>
                                                    <span className='dialog-summary-cont--headeText'>{DELIVERY_TIME}</span>
                                                    {/*<span className='dialog-summary-cont--subtext'>{`${formatAMPM(selectedValue?.data?.delivery_details?.deliveredTime)} (Quoted ${formatAMPM(selectedValue?.data?.delivery_details?.quotedDeliveryTime)})`}</span>*/}
													<span className='dialog-summary-cont--subtext'>{`${formatAMPM(selectedValue?.data?.delivery_details?.deliveredTime)}`}</span>
                                                    <span className='dialog-summary-cont--subtext'>{`${formatMonth(selectedValue?.data?.delivery_details?.deliveredTime)}`}</span>
                                                </div>
                                            </div>
                                            :
                                            null}
                                    <Divider />
                                    <div className='dialog-summary-cont--subContPad'>
                                        <span className='dialog-summary-cont--subtext-label'>{STORE_LOCATION}</span>
                                        <span className='dialog-summary-cont--subtext'>{`${selectedRow?.storeDetails}`}</span>
                                    </div>
                                    <Divider />
                                    <div className='dialog-summary-cont--subContPad2'>
                                        <div className='dialog-summary-cont--subContStart'>
                                            <span className='dialog-summary-cont--headeText'>{CUSTOMER_TEXT}</span>
                                            <span className='dialog-summary-cont--subtext'>{`${selectedValue?.data?.delivery_details?.customerName || ''}`}</span>
                                        </div>
                                        {
                                            selectedValue?.data?.order_status === 'COMPLETE' ?
                                                <div className='dialog-summary-cont--subContStart'>
                                                    <span className='dialog-summary-cont--headeText'>{DRIVER_TEXT}</span>
                                                    <span className='dialog-summary-cont--subtext'>{`${selectedValue?.data?.delivery_details?.driverName || ''}`}</span>
                                                </div>
                                                : null}
                                    </div>
                                </CardContent>
                            </Card>
                            <Card sx={{ paddingBottom: '5px', marginBottom: '8px', height: 'auto' }}>
                                <CardContent sx={{ textAlign: 'left', padding: 0 }}>
                                    <Typography variant='h6' component='div'
                                        sx={{
                                            padding: '16px', fontFamily: 'Basis Grotesque Pro',
                                            borderBottom: 'none',
                                            display: 'flex', justifyContent: 'start',
                                            fontSize: '16px', fontWeight: 'bold', lineHeight: '22px'
                                        }}>{OREDER_RECIPT_TEXT}</Typography>
                                    <div style={{ overflow: 'auto', height: `${listHeight}px` }}>
                                        <div className='dialog-summary-cont--smainCont' style={{ minHeight: '80px', height: 'auto' }}>

                                            {selectedValue?.data?.order_items.map((item, index) => {
                                                {/* {itemList.map((item, index)=> { */ }
                                                return (
                                                    <div key={index} className='dialog-summary-cont--subCont'>
                                                        <span className='dialog-summary-cont--subtext-label'>{`${item?.quantity} X   ${getItemNameOrderDetailsCard(item)}`}</span>
                                                        <span className='dialog-summary-cont--subtext-label'>${item?.item_price}</span>
                                                    </div>
                                                )
                                            })}
                                            <Divider />
                                            <div className='dialog-summary-cont--subCont'>
                                                <span className='dialog-summary-cont--subtext'>{SUBTOTAL_TEXT}</span>
                                                <span className='dialog-summary-cont--subtext'>${selectedValue?.data?.order_subTotal}</span>
                                            </div>
                                            <div className='dialog-summary-cont--subCont'>
                                                <span className='dialog-summary-cont--subtext'>{TAX_TEXT}</span>
                                                <span className='dialog-summary-cont--subtext'>${selectedValue?.data?.order_taxes}</span>
                                            </div>
                                            <Divider />
                                            <div className='dialog-summary-cont--subCont'>
                                                <span className='dialog-summary-cont--subtext'>{MARKET_TEXT}</span>
                                                <span className='dialog-summary-cont--subtext'>-${selectedValue?.data?.marketPlace_fee || '0'}</span>
                                            </div>
                                            <div className='dialog-summary-cont--subCont'>
                                                <span className='dialog-summary-cont--subtext'>{CUSTOMER_REFUND_TEXT}</span>
                                                <span className='dialog-summary-cont--subtext'>-${selectedValue?.data?.customerRefund || '0'}</span>
                                            </div>
                                            <Divider />
                                            <div className='dialog-summary-cont--subCont'>
                                                <span className='dialog-summary-cont--subtext-label'>{PAYOUT_TEXT}</span>
                                                <span className='dialog-summary-cont--subtext-label'>${selectedValue?.data?.payout}</span>
                                            </div>
                                        </div>
                                    </div>

                                </CardContent>
                            </Card>
							{enablepaymentsTab && 
								<Card sx={{ paddingBottom: '5px', marginBottom: '8px', height: 'auto' }}>
									<CardContent sx={{ textAlign: 'left', padding: 0 }}>
										<Typography variant='h6' component='div'
											sx={{
												padding: '16px', fontFamily: 'Basis Grotesque Pro',
												borderBottom: '1px solid rgb(241, 241, 241)',
												borderBottom: 'none',
												display: 'flex', justifyContent: 'start',
												fontSize: '16px', fontWeight: 'bold', lineHeight: '22px'
											}}>
											{TRANS_TEXT}</Typography>
										<div className='dialog-summary-cont--subCont'>
											<span className='dialog-summary-cont--subtext-label'>{`Transaction #${selectedValue?.transactionId} (${selectedValue?.data?.delivery_details?.driverName ? 'Delivery' : 'Pickup'})`}</span>
											<span className='dialog-summary-cont--subtext'>{`$${selectedValue?.data?.payout}`}</span>
										</div>
									</CardContent>
								</Card>
							}

                        </DialogContent> :
                            <DialogContent className='dialog-summary-cont--errorcontent'>
                                <Card className='dialog-summary-cont--errorcontent2'>
                                    <div className='error-cont'>
                                        <span className='dialog-summary-cont--cancelled'>
                                            <WarningAmberIcon className='dialog-summary-cont--cancelledIcon' /> {SERVER_ERROR}
                                            <p className='dialog-summary-cont--statustext'>{SERVER_ERROR_DESC}</p></span>
                                        </div>
                                </Card>
                            </DialogContent>}

                    </>}

                </Dialog >
            }
        </>

    );
}

export default OrderDetailsCard;